import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { Subscription } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-shimano-image-zoom',
  templateUrl: './shimano-image-zoom.component.html',
  styleUrls: ['./shimano-image-zoom.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgxImageZoomModule],
})
export class ShimanoImageZoomComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  myThumbnail = 'null';
  myFullresImage: string;
  imageUpdate = false;
  isDesktop = false;
  isMissing: any;
  csDesktopWidth = this.breakpointService.getSize(BREAKPOINT.lg);
  productSubcription$: Subscription;

  constructor(
    private breakpointService: BreakpointService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    const imageZoom = document.querySelector('app-shimano-image-zoom');
    imageZoom.setAttribute('style', 'display:none');
    this.isDesktop = window.innerWidth >= this.csDesktopWidth;
    this.myThumbnail = this.storageService.getSessionStorageItem('pdp-product');
    this.myFullresImage = this.storageService.getSessionStorageItem('pdp-product-full');
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.productSubcription$ = this.componentService.productPDP$.subscribe((triggered) => {
      this.imageUpdate = triggered;
      const imageZoom = document.querySelector('app-shimano-image-zoom');
      setTimeout(() => {
        if (triggered) {
          this.myThumbnail = this.storageService.getSessionStorageItem('pdp-product');
          this.myFullresImage = this.storageService.getSessionStorageItem('pdp-product-full');
          imageZoom.setAttribute('style', 'display:block');
        }
      }, 1000);
    });
    this.cdr.detectChanges();
  }

  ngAfterViewChecked() {
    this.myThumbnail = this.storageService.getSessionStorageItem('pdp-product');
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.productSubcription$) {
      this.productSubcription$.unsubscribe();
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.isDesktop = window.innerWidth >= this.csDesktopWidth;
  }
}
